import React from "react";

export const Dialog = ({ open, onOpenChange, children }) => {
  if (!open) return null;
  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4"
      onClick={() => onOpenChange?.(false)}
    >
      <div
        className="w-full max-w-2xl max-h-[90vh] flex flex-col overflow-hidden rounded-xl bg-white shadow-xl"
        onClick={(e) => e.stopPropagation()}
      >
        {children}
      </div>
    </div>
  );
};

export const DialogContent = ({ children, className = "" }) => (
  <div className={`flex flex-col flex-1 min-h-0 ${className}`}>{children}</div>
);

export const DialogHeader = ({ children, className = "" }) => (
  <div className={`flex-shrink-0 px-4 sm:px-6 pt-4 sm:pt-6 pb-2 ${className}`}>
    {children}
  </div>
);

export const DialogTitle = ({ children, className = "" }) => (
  <h2 className={`text-lg sm:text-xl font-semibold ${className}`}>{children}</h2>
);

export const DialogFooter = ({ children, className = "" }) => (
  <div className={`flex-shrink-0 flex justify-end gap-2 px-4 sm:px-6 py-4 border-t border-secondary-200 ${className}`}>
    {children}
  </div>
);

export const DialogTrigger = ({ asChild, children, onClick }) => {
  return React.cloneElement(children, { onClick });
};
